export const DETERMINATION_OUTCOMES = ["deny", "not available", "incomplete", "approve"] as const;

export type DeterminationOutcome = typeof DETERMINATION_OUTCOMES[number];

export interface DeterminationProductsContent {
  readonly approval_length?: string | null;
  readonly authorization_type?: string[] | null;
  readonly mony?: string | null;
  readonly product_type?: string | null;
  readonly product_id?: string | null;
  readonly approval_length_custom_duration?: string | null;
  readonly approval_length_custom_unit_of_time?: string | null;
}

export interface QuestionRationale {
  questionnaireId: number
  questionId: string
  rationale: string
}

export interface DeterminationContent {
  // multiple denial rationales can shown in a determination based on the user's answers
  readonly denyRationales?: Array<QuestionRationale>,
  readonly determination?: DeterminationOutcome | null;
  readonly note?: string;
  readonly notes?: Array<string>,
  readonly rationale?: string | null;
  readonly auto_approve?: boolean;
  readonly auto_renewal?: boolean;
  readonly products?: Array<DeterminationProductsContent>;
  readonly next_question?: string,
}

export const DETERMINATION_OUTCOMES_LABELS: Record<DeterminationOutcome, string> = {
  deny: "Deny",
  "not available": "Not Available",
  incomplete: "Incomplete",
  approve: "Approve",
};
